import { render, staticRenderFns } from "./dialog-img.vue?vue&type=template&id=2ee71eba&scoped=true&"
import script from "./dialog-img.vue?vue&type=script&lang=js&"
export * from "./dialog-img.vue?vue&type=script&lang=js&"
import style0 from "./dialog-img.vue?vue&type=style&index=0&id=2ee71eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee71eba",
  null
  
)

export default component.exports